import React from 'react';
import styled from 'styled-components';
import { GlobalStyle } from 'stylecomponents';

const Container = GlobalStyle.BasicBlock.extend`
`
const Header = styled.div`
  font-size: 20px;
  color: #4A4A4A;
  border-bottom: solid 1px #D9D9D9;
  padding: 20px;
  font-weight: bold;
`

const Main = styled.div`
  padding: 16px;
`

const Flex = styled.div`
  display: flex;
  margin-bottom: 15px;
  align-items: center;
`

const Tag = styled.div`
  font-size: 14px;
  color: #4a4a4a;
  font-weight: ${props => props.weight? props.weight:500};
  margin-left: ${props => props.marginLeft? props.marginLeft:0}px;
  min-width: ${({ minWidth }) => minWidth ? `${minWidth}px` : 0};
  word-break: break-all;
`

const Span = styled.span`
  color: #4A90E2;
  font-weight: 500;
  text-decoration: underline;
`

const ProductDetail = ({
  isPurchase,
  sellLimit,
  selllimittype,
  selllimitval,
  minlimit,
  maxlimit,
  notice,
  bonus,
  commission,
}) => (
  isPurchase ?
  (
    <Container>
      <Header>商品詳情</Header>
      <Main>
        <Flex>
          <Tag minWidth={112}>交易地點與時間：</Tag>
          <Tag weight={400}>{notice}</Tag>
        </Flex>
        <Flex>
          <Tag>提示：</Tag>
          <Tag weight={400}>
            出售金額下限(台幣NT) {minlimit}元<br/>
            出售金額上限(台幣NT) {maxlimit}元
          </Tag>
        </Flex>
        {
          (sellLimit > 0) && (
            <Tag>
              此『虛寶市集-遊戲幣收購區』會員已設定【{selllimittype > 0 ? selllimittype : selllimitval}週內】購買遊戲幣的週期限制
              因您於『虛寶市集-遊戲幣出售區』無購買紀錄所以無法販售商品，不予收購此筆交易!
            </Tag>
          )
        }
      </Main>
    </Container>
  )
  :
  (
    <Container>
      <Header>商品詳情</Header>
      <Main>
        <Flex>
          <Tag minWidth={112}>交易地點與時間：</Tag>
          <Tag weight={400}>{notice}</Tag>
        </Flex>
        <Flex>
          <Tag>提示：</Tag>
          <Tag weight={400}>{`發財金積點 ${bonus} 點 (`}<Span>非VIP會員無積點</Span>)</Tag>
        </Flex>
        <Tag weight={400} marginLeft={40}>{`買家(會員)負擔手續費${commission}%(內含) 元 (買家可累積發財金，索取發票中千萬)`}</Tag>
      </Main>
    </Container>
  )
)

export default ProductDetail;